import {Component, Input, OnInit} from '@angular/core';
import {DOState} from "../../digitalout/digitalOutStatus";
import {cIOMAPPEDSERVO} from "../mappedservoData";
import {MappedservolisterComponent} from "../mappedservolister/mappedservolister.component";

@Component({
  selector: 'app-mappedservodetails',
  templateUrl: './mappedservodetails.component.html',
  styleUrls: ['./mappedservodetails.component.css']
})
export class MappedservodetailsComponent implements OnInit {
  @Input()
  refNumber: number = -1;
  ioMappedServo: cIOMAPPEDSERVO;

  constructor(mappedservolisterComponent: MappedservolisterComponent) {
    this.ioMappedServo = new cIOMAPPEDSERVO();
    mappedservolisterComponent.Add(this);
  }

  ngOnInit(): void {
  }

  UpdateState(ioMappedServo: cIOMAPPEDSERVO): void
  {
    this.ioMappedServo = ioMappedServo;
  }


}
